import { render, staticRenderFns } from "./reportOverview.vue?vue&type=template&id=4899d97e&scoped=true&"
import script from "./reportOverview.vue?vue&type=script&lang=js&"
export * from "./reportOverview.vue?vue&type=script&lang=js&"
import style0 from "./reportOverview.vue?vue&type=style&index=0&id=4899d97e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4899d97e",
  null
  
)

export default component.exports